import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../types";
import { User } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type UserGetService<T> = (
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: UserGetService<EntityGet<User>> = async (id, opts = {}) => {
  const docRef = doc(db, `/user/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<User>)
    ) as EntityGet<User>;
  }
  return null;
};

export default get;
